import { z } from 'zod';
/**
 * One organization: the top of the hierarchy a practice group, a practice, and a provider hang
 * from, and the boundary almost everything else in primary is scoped by.
 */
export const OrganizationSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    name: z.string(),
    slug: z
        .string()
        .nullable()
        .describe('How the login page addresses the organization. Null until single sign-on is set up.'),
    ssoEnabled: z
        .boolean()
        .describe('Whether members sign in through the organization, not a password.'),
});
export const OrganizationReadResponseSchema = z.object({ organization: OrganizationSchema });
//# sourceMappingURL=read.js.map